import React, {useCallback, useState} from 'react';
import "./test.less"
import "./App.less"
import {Layout} from "antd";
import SiteHeader from "./components/site-header/SiteHeader";
import Sidebar from "./components/page_sidebar/Sidebar";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import * as RouteWays from "./enums/routes"
import HomePage from "./pages/home-page/HomePage";
import StaffPage from "./pages/staffs-page/StaffPage";
import NewsPage from "./pages/news-page/NewsPage";
import StructurePage from "./pages/structure-page/StructurePage";
import DepartmentsPage from "./pages/departments/departments-page";
import DepartmentPage from "./pages/departments/department-page";
import OfficePage from "./pages/office-page";
import NewsItemPage from "./pages/news-page/newsItem-page";
import {AuthProvider} from "./context/authContext";
import AdmissionSchedulePage from "./pages/admissionSchedule-page";
import VacanciesPage from "./pages/vacancies-page/VacanciesPage";
import AdministrationPage from "./pages/administratioin-page/AdministrationPage";
import ContactsPage from "./pages/contacts-page/ContactsPage";
import PublicInformationPage from "./pages/publicInfo-page";
import PublicInformationItemPage from "./pages/publicInfoItem-page";
import TenderProcurementsPage from "./pages/tenderProcurements-page";
import GeneralInfoPage from "./pages/generalInfo-page";
import GeneralInfoItemPage from "./pages/generalInfoItem-page";
import AboutPage from "./pages/about-page/AboutPage";
import AboutItemPage from "./pages/aboutItem-page/AboutItemPage";
import ToggleDrawerButton from "./components/site-header/components/toggleDrawer-button/ToggleDrawerButton";
import {useDevice} from "./context/deviceContext";
import SupCouncilPage from "./pages/supCouncil-page/SupCouncilPage";
import SupCouncilItemPage from "./pages/supCouncilItem-page/SupCouncilItemPage";
import SurgeryRequestsPage from "./pages/surgeryRequests-page/SurgeryRequestsPage";
import SurgerySchedulePage from "./pages/surgerySchedule-page/SurgerySchedulePage";
import ProtectedRoute from "./components/protected-route/ProtectedRoute";


const {Header, Content} = Layout

function App() {
  const {isMobile} = useDevice()
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  const toggleDrawer = useCallback(() => {
    setIsDrawerVisible((currentValue) => !currentValue)
  }, [])

  const isOpenDrawerButtonVisible = isMobile && !isDrawerVisible

  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout className="site_layout">
          <Header className="site_header">
            {isMobile && <div className="site-header-menu-slot">
              {isOpenDrawerButtonVisible && (
                <ToggleDrawerButton onClick={() => setIsDrawerVisible(true)}/>
              )}
            </div>}
            <SiteHeader/>
          </Header>
          <Layout className="site_body">
            <Sidebar isDrawerVisible={isDrawerVisible} isMobile={isMobile} toggleDrawer={toggleDrawer}/>
            <Content className="content_wrapper">
              <Routes>
                <Route path={RouteWays.HOME} element={<HomePage/>}/>
                <Route path={RouteWays.STAFF} element={<StaffPage/>}/>
                <Route path={RouteWays.STRUCTURE} element={<StructurePage/>}/>
                <Route path={RouteWays.DEPARTMENTS} element={<DepartmentsPage/>}/>
                <Route path={RouteWays.DEPARTMENT} element={<DepartmentPage/>}/>
                <Route path={RouteWays.OFFICE} element={<OfficePage/>}/>
                <Route path={RouteWays.NEWS} element={<NewsPage/>}/>
                <Route path={RouteWays.NEWS_ITEM} element={<NewsItemPage/>}/>
                <Route path={RouteWays.ADMISSION_SCHEDULE} element={<AdmissionSchedulePage/>}/>
                <Route path={RouteWays.VACANCIES} element={<VacanciesPage/>}/>
                <Route path={RouteWays.ADMINISTRATION} element={<AdministrationPage/>}/>
                <Route path={RouteWays.CONTACTS} element={<ContactsPage/>}/>
                <Route path={RouteWays.GENERAL_INFORMATION} element={<GeneralInfoPage/>}/>
                <Route path={RouteWays.GENERAL_INFORMATION_ITEM} element={<GeneralInfoItemPage/>}/>

                <Route path={RouteWays.PUBLIC_INFORMATION} element={<PublicInformationPage/>}/>
                <Route path={RouteWays.PUBLIC_INFORMATION_ITEM} element={<PublicInformationItemPage/>}/>
                <Route path={RouteWays.TENDER_PROCUREMENTS} element={<TenderProcurementsPage/>}/>
                <Route path={RouteWays.ABOUT} element={<AboutPage/>}/>
                <Route path={RouteWays.ABOUT_ITEM} element={<AboutItemPage/>}/>
                <Route path={RouteWays.OVERSIGHT_COMMITTEE} element={<SupCouncilPage/>}/>
                <Route path={RouteWays.OVERSIGHT_COMMITTEE_ITEM} element={<SupCouncilItemPage/>}/>
                <Route element={<ProtectedRoute/>}>
                  <Route path={RouteWays.SURGERY_REQUESTS} element={<SurgeryRequestsPage/>}/>
                  <Route path={RouteWays.SURGERY_SCHEDULE} element={<SurgerySchedulePage/>}/>
                </Route>


              </Routes>
            </Content>
          </Layout>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
